import { Text } from "../../config/Constants";

export type User = {
  email: string;
  password: string;
};
type Error = (a: any) => void;

export const Validation = (user: User, setError: Error) => {
  if (user.email === "" && user.password === "") {
    setError({
      email: Text.loginEnterEmail,
      password: Text.loginEnterPassword,
    });
    return false;
  } else if (user.email === "") {
    setError({
      email: Text.loginEnterEmail,
      password: "",
    });
    return false;
  } else if (user.password === "") {
    setError({
      email: "",
      password: Text.loginEnterPassword,
    });
    return false;
  } else if (!validateEmail(user.email)) {
    setError({
      email: Text.loginInvalidEmail,
      password: "",
    });
    return false;
  } else {
    setError({
      email: "",
      password: "",
    });
    return true;
  }
};

export const validateEmail = (email: string) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};
